import { render, staticRenderFns } from "./submitSuccess.vue?vue&type=template&id=27e86c00&scoped=true"
import script from "./submitSuccess.vue?vue&type=script&lang=js"
export * from "./submitSuccess.vue?vue&type=script&lang=js"
import style0 from "./submitSuccess.vue?vue&type=style&index=0&id=27e86c00&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e86c00",
  null
  
)

export default component.exports